import React from 'react';
import { Link, withRouter, NavLink as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import ModalComponent from '../../../_components/common/Modal';
import { Modal, ModalHeader, ModalBody, ModalFooter, Tooltip,Input } from 'reactstrap';
// import { FilterForm } from './FormData';
import { connect } from 'react-redux';
import { AnalyzeAction } from '../../../_actions/Analyze/analyze.action'
import { competencyListAction } from '../../../_actions/Analyze/competencyList.action'
import { lndAction} from '../../../_actions/Analyze/lnd.action'
import { attritionPredictorAction } from '../../../_actions/Analyze/attritionPredictor.action'
import { getPaAnanlyzeTeamListAction } from '../../../_actions/Analyze/getPaAnanlyzeTeamList.action'
import './index.css'
import { orgAdminAction, saveTeamDetailsAction, saveModulePermissionsAction, analyseActions, superAdminAction } from '../../../_actions';

import { Subject } from 'rxjs';
import { debounceTime, throttleTime, takeUntil } from 'rxjs/operators'


const sub$ = new Subject();
const TakeUntillAvailable$ = new Subject()

export class SideNavBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            teamName: '',
            teamId: '',
            openTeamModal: false,
            FilterForm: [],
            openFilterModal: false,
            TeamData: 'sdvsdv',
            analyzeFilterData: null,
            // teamId: '',
            tooltipOpen: false,
            tooltipOrganisation: false,
            applyFilter: false,
            assessorArray: [],
            // teamName: '',
            footerNonSubmitButton: [{
                'buttonName': 'Apply Filters'
            }, {
                'buttonName': 'Remove All Filters'
            }, {
                'buttonName': 'Cancel'
            }],
            addingToNewArray: [],
            multiFilter_filteredData: [],
            analyzeDataFilterData: {},
            countOfFilteredObj: 0,

            FilteredFormnAnalyze: {
                team_assessment_id: []
            },
            data_ob_filtered: {
                team_members: []
            },
            isDisabled: false,


            assessorListEnabledArr: [],

            allRelationSelect: true,

            //add loader to set save_assessor_ids and save_assessor_group added because dispatches are async
            changeTeamState: true,

            prevOrgId: 0,

            collapseSideNav: false,

            hideSideNav: false,
            
        }
        this.toggle = this.toggle.bind(this);
        this.toggleOrganisationTooltip = this.toggleOrganisationTooltip.bind(this)
        this.applyFilter = this.applyFilter.bind(this);
    }

    resize = () => {
        let currentHideNav = (window.innerWidth <= 1024);
        this.setState({hideSideNav: currentHideNav, collapseSideNav: !currentHideNav});
    }

    componentWillMount() {
        this.resize()

        window.addEventListener("resize", this.resize);
    }

    componentDidMount() {
        

        sub$
            .pipe(
                takeUntil(TakeUntillAvailable$),
                debounceTime(800)
            )
            .subscribe(
                ({checkedVal, assessorDetails}) => {
                    
                    const { assessorArray } = this.state;

                    const { saveAssesorGroupListResponse } = this.props;


                    const assessorIdsArr = assessorArray.filter(assessor => assessor.value).map(assessor => assessor.id)
                    

                    const fdTeam_list = {
                        assessor_group_ids: assessorIdsArr,
                        assessment_ids: saveAssesorGroupListResponse.team_members.map(team => team.assessment.id)
                    }

                    this.props.dispatch(analyseActions.get_team_member_id(fdTeam_list))
                    this.setState({ assessorIds: assessorIdsArr })
                    
                }
            )

        if(this.props.saveAssesorGroupListResponse !== '' && this.props.saveAssesorGroupListResponse !== null && this.props.saveAssesorGroupListResponse !== undefined) {
            let counter = 0
            this.props.saveAssesorGroupListResponse.assessor_groups_for_team.map(val => {
                if(val.value) {
                    counter++
                }
            })
            this.setState({
                assessorListEnabledArr: this.props.saveAssesorGroupListResponse.assessor_groups_for_team,
                allRelationSelect: counter === this.props.saveAssesorGroupListResponse.assessor_groups_for_team.length ? true : false,
                changeTeamState: false
            }, () => {
                this.filterStateAnalyze()
            })
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if(prevProps.team_id_group_list_data !== this.props.team_id_group_list_data) {
            if(this.props.team_id_group_list_data !== '' && this.props.analyzeFilterData) {

                
                const { saveAssesorGroupListResponse, team_id_group_list_data } = this.props;


                const filteredObject = this.onClickResponseHandler('Apply Filters', true);

                const newTeamMembers = filteredObject.data.map(obj => {
                    const filteredRelation = team_id_group_list_data.data.team_members.includes(obj.assessment_id)
                    return {
                        is_team_leader: obj.is_team_leader,
                        age: obj.age,
                        filtered: obj.filtered && filteredRelation,
                        relationFilter: filteredRelation,
                        assessment: {
                            created: obj.created,
                            id: obj.assessment_id
                        },
                        user__country__country_name: obj.country,
                        user__date_of_birth: obj.user__date_of_birth,
                        user__full_name: obj.user__full_name,
                        user_email: obj.user_email,
                        user__gender: obj.gender,
                        user_details: [
                            {
                                annual_income: obj.annual_income,
                                city: obj.city,
                                designation: obj.Designation,
                                family_type: obj.family_type,
                                industry__demographic_name: obj.industry,
                                marital_status: obj.marital_status,
                                no_of_children: obj.children,
                                occupation: obj.occupation,
                                qualification__demographic_name: obj.Qualification,
                                tenure_in_company: obj.tenure_in_company,
                                work_experience: obj.work_experience,
                            }
                        ]
                    }
                })

                const setFilterBool = (team, id) => {
                    return team_id_group_list_data.data.team_members.includes(id)
                }

                const updatedData = this.state.assessorArray.length === 0 ? this.getReformatAssessorGroupList(this.props.analyzeFilterData.assessor_groups_for_team) : this.state.assessorArray;
                
                const fd1 = {
                    'assessor_groups_for_team': updatedData,
                    'team_members': newTeamMembers
                }

                const assessmentIdsT = [...newTeamMembers.filter(val => val.filtered && val.relationFilter).map(team => team.assessment.id)];
                
                const assessorIdsT = [...fd1.assessor_groups_for_team.filter(team => team.value).map(team => team.id)]


                //call swot/focus_area/review_question api's : this function sorts api's and the adjusts number of api calls need to be made according module permission
                this.apiCallStackInBackground(assessorIdsT, assessmentIdsT, fd1)

            }
        }

        if(prevProps.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '' && this.props.saveAssesorGroupListResponse !== null && this.props.saveAssesorGroupListResponse !== undefined) {
                let counter = 0
                this.props.saveAssesorGroupListResponse.assessor_groups_for_team.map(val => {
                    if(val.value) {
                        counter++
                    }
                })
                this.setState({
                    assessorListEnabledArr: this.props.saveAssesorGroupListResponse.assessor_groups_for_team,
                    allRelationSelect: counter === this.props.saveAssesorGroupListResponse.assessor_groups_for_team.length ? true : false
                }, () => {
                    this.filterStateAnalyze()
                })
            }
        }

        if(prevProps.assessorGroupsResponse !== this.props.assessorGroupsResponse) {
            if(this.props.assessorGroupsResponse !== '') {
                this.props.dispatch({
                    type: 'REMOVE_FILTER_FORM'
                })
            }
        }

        if(prevProps.teamId !== this.props.teamId) {
            const runTest = (tableData, teamId) => {
                var tableDataArray = []
                for (var key in tableData) {
                    if (tableData.hasOwnProperty(key)) {
                        tableDataArray = tableDataArray.concat(tableData[key])
                    }
                }

                var sortedArray =  tableDataArray.sort(function(a, b) { 
                    return a.team_type - b.team_type  ||  a.team_name.localeCompare(b.team_name);
                });
                
                let teamIdReturn = '';

                for (let i = 0; i < sortedArray.length; i++) {
                    const element = sortedArray[i];
                    if(element.id == teamId) {
                        teamIdReturn = element.team_name
                    }
                    
                }

                return teamIdReturn
            }
            this.setState({
                teamName: runTest(this.props.getPaAnanlyzeTeamListResponse.data, this.props.teamId)
            })
        }

        if(prevProps.saveAssesorIdsResponse !== this.props.saveAssesorIdsResponse) {
            //call team_member_id for further filter in componentdidupdate team_member_id condition
            if(Object.keys(this.props.saveAssesorIdsResponse).length && this.state.changeTeamState) {
                const fdTeam_list = {
                    assessor_group_ids: this.props.saveAssesorIdsResponse.assessorIds,
                    assessment_ids: this.props.saveAssesorIdsResponse.assessmentIds
                }
                this.props.dispatch(analyseActions.get_team_member_id(fdTeam_list))
            }
        }
    }

    apiCallStackInBackground = (assessorIds, assessmentIds, fd1) => {

        const fd = {
            "assessorIds": assessorIds,
            "assessmentIds": assessmentIds,
        }

        const postRequestObj = {"team_assessment_id": assessmentIds,"relation_group_ids": assessorIds}
        const competencyPostObj = { "analytics_organisation": +this.props.match.params.id }


        //permissions according to modulePermissions variable, this function returns a array of objects with analyze, LandD and attrition_predictor
        const getStatusPermissions = (permissionArray) => {

            //api array object -- allow is false as initial and change according to permissions provided
            let apiDataArrayObject = [
                {action: AnalyzeAction.AnalyzeDataAction, post: postRequestObj, allow: false}, {action: lndAction.lndDataAction, post: postRequestObj, allow: false}, {action: attritionPredictorAction.attriPreDataAction, post: postRequestObj, allow: false}
            ]


            //map permissions to check module_list_id
            permissionArray.map((permissions) => {

                // module_list_id === 1 || 2 || 3 will be equal to SWOT/FOCUS_AREA/REVIEW_QUESTION. because analyze api apiDataArrayObject[0] gives all the following data
                if(permissions.module_list_id === 1 || permissions.module_list_id === 2 || permissions.module_list_id === 3) {
                    apiDataArrayObject[0].allow = true
                }else if(permissions.module_list_id === 8) {
                    //module_list_id === 8  is L and D api permission
                    apiDataArrayObject[1].allow = true
                }else if(permissions.module_list_id === 9) {
                    //module_list_id === 9  is Attrition predictor api permission
                    apiDataArrayObject[2].allow = true
                }
            })

            //return permission object which is Unsorted and has the api function and post request and allow boolean. allow boolean will be checked in callback section.
            //sort allow true to be in first of api
            const sortedApiDataArrayObject = apiDataArrayObject.sort((x,y) => {
                // true values first
                return (x.allow === y.allow)? 0 : x.allow? -1 : 1;
                // false values first
                // return (x.allow === y.allow)? 0 : x.allow? 1 : -1;
            })
            return sortedApiDataArrayObject
        }
        


        // return competency api object. takes in module permissions.
        const getStatusPermissionsCompetency = (permissionArray) => {

            let apiDataObject = {action:superAdminAction.getAnalyticsMetricListHandler, post: competencyPostObj, allow: false}

            //map permissions to check module_list_id
            permissionArray.map((permissions) => {
                //module_list_id === 7 is competency module ID.
                //check if already called the competency api.
                if(permissions.module_list_id === 7 && this.state.changeTeamState) {
                    apiDataObject.allow = true
                }
            })

            return apiDataObject

        }


        const modulePermissions = this.props.getModulePermissionsListData.data.message

        // competency api section according to module permissions
        const competencyApi = getStatusPermissionsCompetency(modulePermissions)
        
        //unsorted api array which contains allow boolean according to module permissions
        let UnsortedApiActions = getStatusPermissions(modulePermissions)

        //shift array arrangements according to landing page. if page is in SWOT/FOCUS_AREA/REVIEW_QUESTIONS then we dont have to change array order
        if(this.props.location.pathname.includes('learning-and-development')) {
            UnsortedApiActions = [UnsortedApiActions[1], UnsortedApiActions[2], UnsortedApiActions[0]]
        }else if(this.props.location.pathname.includes('attrition-predictor')) {
            UnsortedApiActions = [UnsortedApiActions[2], UnsortedApiActions[1], UnsortedApiActions[0]]
        }


        const callbackApiStack = () => {
            //UnsortedApiActions is sorted according to allow boolean. true will always be first. if false then after the recent false all others will be false.
            if(UnsortedApiActions[0].allow) {
                this.props.dispatch(UnsortedApiActions[0].action(UnsortedApiActions[0].post, () => {
                    if(UnsortedApiActions[1].allow) {
                        this.props.dispatch(UnsortedApiActions[1].action(UnsortedApiActions[1].post, () => {
                            if(UnsortedApiActions[2].allow) {
                                this.props.dispatch(UnsortedApiActions[2].action(UnsortedApiActions[2].post))
                            }
                        }))
                    }
                }))
            }
        }

        this.setState({
            // this ensures save assessor group wont exceed callback limit because we are checking changeTeamState === true on change of save assessor groups
            changeTeamState: false
        }, () => {

            this.props.dispatch(analyseActions.saveAssessorIds(fd))
            this.props.dispatch(analyseActions.saveAssessorGroups(fd1))


            if(competencyApi.allow) {
                this.props.dispatch(competencyApi.action(competencyApi.post, () => {
                    callbackApiStack()
                }, 'competency'))
            }else {
                callbackApiStack()
            }
        })
    }

    filterStateAnalyze = () => {
        const {analyzeFilterData} = this.props;
        if(analyzeFilterData) {
            if(analyzeFilterData !== null) {
                if(this.props.filter_form_updated === false) {
                    let family_type_obj = {
                        mainLabel: 'Family Type:',
                        type: 'checkbox',
                        data: []
                    }
        
                    let city_obj = {
                        mainLabel: 'City:',
                        type: 'checkbox',
                        data: []
                    }
        
                    let country_obj = {
                        mainLabel: 'Country:',
                        type: 'checkbox',
                        data: []
                    }
        
                    let occupation_obj = {
                        mainLabel: 'Occupation:',
                        type: 'checkbox',
                        data: []
                    }
        
                    let designation_obj =  {
                        mainLabel: 'Designation:',
                        type: 'checkbox',
                        data: []
                    }
        
                    let qualification_obj = {
                        mainLabel: 'Qualification:',
                        type: 'checkbox',
                        data: []
                    }
        
                    let industry_obj = {
                        mainLabel: 'Industry:',
                        type: 'checkbox',
                        data: []
                    }

                    let gender_obj = {
                        mainLabel: 'Gender:',
                        type: 'checkbox',
                        data: []
                    }
        
                    //family type
                    let family_type_different_types = []
                    let uniqueArray_family_type = []
        
                    //city
                    let city_different_types = []
                    let uniqueArray_city = []
        
                    //country
                    let country_different_types = []
                    let uniqueArray_country = []
        
                    //occupation
                    let occupation_different_types = []
                    let uniqueArray_occupation = []
        
                    //designation
                    let designation_different_types = []
                    let uniqueArray_designation = []
        
                    //qualifiation
                    let qualifiation_different_types = []
                    let uniqueArray_qualification = []
        
                    //industry
                    let industry_different_types = []
                    let uniqueArray_industry = []

                    //gender
                    let gender_different_types = []
                    let uniqueArray_gender = []
    
                    //non dynamic formdata INPUT
                    let FilterForm = [];
                    
                    FilterForm.push({
                        heading: 'Personal Details'
                    })
    
                    FilterForm.push({
                        mainLabel: 'Age:',
                        type: 'number',
                        data: [{
                            key: 'age_between',
                            value: '',
                            name: 'age_between',
                            label: 'Between',
                            dataFilter: 'age'
                        }, {
                            key: 'age_and',
                            value: '',
                            name: 'age_and',
                            label: 'and',
                            dataFilter: 'age'            
                        }],
                    })
    
                    
    
                    FilterForm.push({
                        mainLabel: 'No of Children:',
                        type: 'number',
                        data: [{
                            key: 'No of Children_between',
                            value: '',
                            name: 'No of Children_between',
                            label: 'Between',
                            dataFilter: 'no_of_children'
                        }, {
                            key: 'No of Children_and',
                            value: '',
                            name: 'No of Children_and',
                            label: 'and',
                            dataFilter: 'no_of_children'            
                        }],
                    })

                    FilterForm.push({
                        mainLabel: 'Marital status:',
                        type: 'checkbox',
                        data: []
                    })

                    FilterForm.push(gender_obj)
    
                    FilterForm.push({
                        heading:'Work Details'
                    })
    
                    
    
                    

                    let maritalCounter = {
                        counter: 0,
                        radio: []
                    }
                    let annualIncome = 0
                    let work_experience = 0
                    let tenure_in_company = 0
                    let no_of_children = 0
                    let age = 0
        
                    analyzeFilterData.team_members.map(val => {

                        if(val.age !== 'Not specified') {
                            age++
                        }

                        //marital status
                        if(val.user_details.length) {
                            if(val.user_details[0].marital_status !== 'Not specified' && val.user_details[0].marital_status !== '') {
                                maritalCounter.counter++
                                maritalCounter.radio.push(val.user_details[0].marital_status)
                            }
                        }
                        //no_of_children
                        if(val.user_details.length) {
                            if(val.user_details[0].no_of_children !== 'Not specified' && val.user_details[0].no_of_children !== '') {
                                no_of_children++
                            }
                        }
                        //tenure_in_company
                        if(val.user_details.length) {
                            if(val.user_details[0].tenure_in_company !== 'Not specified' && val.user_details[0].tenure_in_company !== 0) {
                                tenure_in_company++
                            }
                        }
                        //annual_income
                        if(val.user_details.length) {
                            if(val.user_details[0].annual_income !== 'Not specified' && val.user_details[0].annual_income !== '') {
                                annualIncome++
                            }
                        }
                        //work_experience
                        if(val.user_details.length) {
                            if(val.user_details[0].work_experience !== 'Not specified' && val.user_details[0].work_experience !== 0) {
                                work_experience++
                            }
                        }

                        //family type
                        if(val.user_details.length !== 0) {
                            family_type_different_types.push(val.user_details[0].family_type)
                        }
        
                        //city
                        if(val.user_details.length !== 0) {
                            city_different_types.push(val.user_details[0].city)
                        }
        
                        //country
                        country_different_types.push(val.user__country__country_name)
        
                        //occupation
                        if(val.user_details.length !== 0) {
                            if(val.user_details[0].occupation === '' || val.user_details[0].occupation === undefined) {
                                occupation_different_types.push("Not specified")
                            }else {
                                occupation_different_types.push(val.user_details[0].occupation)                            
                            }
                        }
        
                        //designation
                        if(val.user_details.length !== 0) {
                            if(val.user_details[0].designation === '') {
                                designation_different_types.push("Not specified")
                            }else {
                                designation_different_types.push(val.user_details[0].designation)
                            }
                        }
        
                        //qualification
                        if(val.user_details.length !== 0) {
                            if(val.user_details[0].qualification__demographic_name === '') {
                                qualifiation_different_types.push("Not specified")
                            }else {
                                qualifiation_different_types.push(val.user_details[0].qualification__demographic_name)
                            }
                        }
        
                        //industry
                        if(val.user_details.length !== 0) {
                            if(val.user_details[0].industry__demographic_name === ''){
                                industry_different_types.push("Not specified")
                            }else {
                                industry_different_types.push(val.user_details[0].industry__demographic_name)
                            }
                        }

                        if(val.user__gender === '') {
                            gender_different_types.push("Not specified")
                        }else {
                            gender_different_types.push(val.user__gender)                            
                        }
        
                    })

                    if(tenure_in_company) {
                        FilterForm.push({
                            mainLabel: 'Tenure in company:',
                            type: 'number',
                            data: [{
                                key: 'Tenure in company_between',
                                value: '',
                                name: 'Tenure in company_between',
                                label: 'Between',
                                dataFilter: 'tenure_in_company'
                            }, {
                                key: 'Tenure in company_and',
                                value: '',
                                name: 'Tenure in company_and',
                                label: 'and',
                                dataFilter: 'tenure_in_company'            
                            }],
                        })
                    }

                    if(work_experience) {
                        FilterForm.push({
                            mainLabel: 'Work Experience:',
                            type: 'number',
                            data: [{
                                key: 'Work Experience_between',
                                value: '',
                                name: 'Work Experience_between',
                                label: 'Between',
                                dataFilter: 'work_experience'            
                            }, {
                                key: 'Work Experience_and',
                                value: '',
                                name: 'Work Experience_and',
                                label: 'and',
                                dataFilter: 'work_experience'            
                            }],
                        })
                    }

                    if(annualIncome) {
                        FilterForm.push({
                            mainLabel: 'Annual income:',
                            type: 'checkbox',
                            data: [
                                {
                                    key: 'Annual income',
                                    value: false,
                                    name: 'Annual income',
                                    label: '< $100,000',
                                    dataFilter: 'annual_income',
                                    data: {
                                        min: 0,
                                        max: 99999
                                    }
                                }, {
                                    key: 'Annual income',
                                    value: false,
                                    name: 'Annual income',
                                    label: '$100,000 - $250,000',
                                    dataFilter: 'annual_income',
                                    data: {
                                        min: 100000,
                                        max: 249000
                                    }
                                }, {
                                    key: 'Annual income',
                                    value: false,
                                    name: 'Annual income',
                                    label: '> $250,000',
                                    dataFilter: 'annual_income',
                                    data: {
                                        min: 250000,
                                        max: Infinity
                                    }
                                }
                            ]
                        })
                    }

                    function removeObjectFromArr(stringToMatch) {
                        let pos = 0
                        FilterForm.map((val, key) => {
                            if(val.mainLabel === stringToMatch) {
                                pos = key
                            }
                        })
                        if(pos) {
                            FilterForm.splice(pos, 1)
                        }
                    }
                    if(maritalCounter.counter) {
                        let pos = 0
                        FilterForm.map((val, key) => {
                            if(val.mainLabel === 'Marital status:') {
                                pos = key
                            }
                        })
                        if(pos) {
                            const uniqueArray_marital_type = maritalCounter.radio.filter(function(item, position) {
                                return maritalCounter.radio.indexOf(item) == position;
                            })
                            uniqueArray_marital_type.map(val => {
                                FilterForm[pos].data.push({
                                    key: 'Marital status',
                                    value: false,
                                    name: 'Marital status',
                                    label: val,
                                    dataFilter: 'marital_status'
                                })
                            })
                        }
                    }else {
                        removeObjectFromArr('Marital status:')
                    }

                    if(!no_of_children) {
                        removeObjectFromArr('No of Children:')
                    }

                    if(!age) {
                        removeObjectFromArr('Age:')
                    }

                    if(!maritalCounter.counter && !no_of_children && !age) {
                        FilterForm.splice(0, 1)
                    }

                    
        
                    //family type
                    uniqueArray_family_type = family_type_different_types.filter(function(item, pos) {
                        return family_type_different_types.indexOf(item) == pos;
                    })
                    uniqueArray_family_type.map(val => {
                        family_type_obj.data.push({
                            key: 'Family Type',
                            value: false,
                            name: 'Family Type',
                            label: val,
                            dataFilter: 'family_type',
                        })
                    })
                    FilterForm.push(family_type_obj)
        
                    //city
                    uniqueArray_city = city_different_types.filter(function(item, pos) {
                        return city_different_types.indexOf(item) == pos;
                    })
        
                    uniqueArray_city.map(val => {
                        city_obj.data.push({
                            key: 'city',
                            value: false,
                            name: 'city',
                            label: val,
                            dataFilter: 'city'
                        })
                    })
                    FilterForm.push(city_obj)
        
                    //country
                    uniqueArray_country = country_different_types.filter(function(item, pos) {
                        return country_different_types.indexOf(item) == pos;
                    })
        
                    uniqueArray_country.map(val => {
                        country_obj.data.push({
                            key: 'country',
                            value: false,
                            name: 'country',
                            label: val,
                            dataFilter: 'user__country__country_name'
                        })
                    })
                    FilterForm.push(country_obj)
        
                    //occupation
                    uniqueArray_occupation = occupation_different_types.filter(function(item, pos) {
                        return occupation_different_types.indexOf(item) == pos;
                    })
        
                    uniqueArray_occupation.map(val => {
                        occupation_obj.data.push({
                            key: 'occupation',
                            value: false,
                            name: 'occupation',
                            label: val,
                            dataFilter: 'occupation'
                        })
                    })
                    FilterForm.push(occupation_obj)
                    
                    //designation
                    uniqueArray_designation = designation_different_types.filter(function(item, pos) {
                        return designation_different_types.indexOf(item) == pos;
                    })
        
                    uniqueArray_designation.map(val => {
                        designation_obj.data.push({
                            key: 'Designation',
                            value: false,
                            name: 'Designation',
                            label: val,
                            dataFilter: 'designation'                
                        })
                    })
                    FilterForm.push(designation_obj)
        
                    //qualification
                    uniqueArray_qualification = qualifiation_different_types.filter(function(item, pos) {
                        return qualifiation_different_types.indexOf(item) == pos;
                    })
        
                    uniqueArray_qualification.map(val => {
                        qualification_obj.data.push({
                            key: 'Qualification',
                            value: false,
                            name: 'Qualification',
                            label: val,
                            dataFilter: 'qualification__demographic_name'                
                        })
                    })
                    FilterForm.push(qualification_obj)
        
                    //industry
                    uniqueArray_industry = industry_different_types.filter(function(item, pos) {
                        return industry_different_types.indexOf(item) == pos;
                    })
        
                    uniqueArray_industry.map(val => {
                        industry_obj.data.push({
                            key: 'industry',
                            value: false,
                            name: 'industry',
                            label: val,
                            dataFilter: 'industry__demographic_name'
                        })
                    })
                    FilterForm.push(industry_obj)
        

                    //gender
                    uniqueArray_gender = gender_different_types.filter(function(item, pos) {
                        return gender_different_types.indexOf(item) == pos;
                    })
        
                    uniqueArray_gender.map(val => {
                        gender_obj.data.push({
                            key: 'user__gender',
                            value: false,
                            name: 'user__gender',
                            label: val,
                            dataFilter: 'user__gender'
                        })
                    })

                    FilterForm.map((val, key) => {
                        if(val.mainLabel === 'Gender:') {
                            val.data = gender_obj.data
                        }
                    })
                    
                    
                    let notFiltered = false
                    let countOfFilteredObj = 0
                    this.props.analyzeFilterData.team_members.map(val => {
                        if(val.filtered !== undefined) {
                            if(val.filtered === true){
                                countOfFilteredObj++
                            }
                        }else {
                            notFiltered = true
                        }
                    })
    
                    if(notFiltered && countOfFilteredObj === 0) {
                        countOfFilteredObj = this.props.analyzeFilterData.team_members.length
                    }
                    
                    this.setState({
                        FilterForm,
                        analyzeDataFilterData: this.props.analyzeFilterData,
                        countOfFilteredObj
                    }, () => {
                        const {dispatch} = this.props;
                        dispatch({
                            type: 'ADD_FILTER_FORM',
                            payload: this.state.FilterForm,
                            filter_used: 'No Filters Applied'
                        })
                    })
                }else {

                    let notFiltered = false
                    let countOfFilteredObj = 0

                    this.props.analyzeFilterData.team_members.map(val => {
                        if(val.filtered !== undefined) {
                            if(val.filtered === true){
                                countOfFilteredObj++
                            }
                        }else {
                            notFiltered = true
                        }
                    })
    
                    if(notFiltered && countOfFilteredObj === 0) {
                        countOfFilteredObj = this.props.analyzeFilterData.team_members.length
                    }
                    this.setState({
                        FilterForm: this.props.FilterForm_reducer,
                        countOfFilteredObj,
                    })
                    
                }
            }
        }
    }

    getOrgTeamReformatData = (tableData) => {

        var tableDataArray = []
        for (var key in tableData) {
            if (tableData.hasOwnProperty(key)) {
                tableDataArray = tableDataArray.concat(tableData[key])
            }
        }

        var sortedArray =  tableDataArray.sort(function(a, b) { 
            return a.team_type - b.team_type  ||  a.team_name.localeCompare(b.team_name);
          });


        const returnData = <div style={{
            maxHeight: '450px',
            overflowY: 'scroll'
        }}>
            {
                sortedArray.length !== 0 &&
                <div className="d-flex flex-row justify-content-between flex-wrap align-items-center">
                    {/* <div className="col-4 mx-auto font-weight-bold">
                        Batch Name
                 </div> */}
                    <div className="col-12 text-center font-weight-bold">
                        Teams
                 </div>
                </div>
            }

            {
                sortedArray.length !== 0 &&
                <div className="d-flex flex-row  flex-wrap align-items-center">
                    {
                        sortedArray.map(
                            (data, i) => {
                                if(this.props.teamName == data.team_name) {
                                    return (<div className="col-4  my-2" key={i}>
                                    <button style={{ backgroundColor: data.team_type === 1 ? '#1F9858' : data.team_type === 2 ? '#436FA0' : '#EE0033' }} key={i} className="btn text-white btn-block" onClick={() => this.onClickTeam(data)} disabled >{data.team_name}</button>
                                </div>)
                                }
                                else {
                                    return (<div className="col-4  my-2" key={i}>
                                    <button style={{ backgroundColor: data.team_type === 1 ? '#1F9858' : data.team_type === 2 ? '#436FA0' : '#EE0033' }} key={i} className="btn text-white btn-block" onClick={() => this.onClickTeam(data)}>{data.team_name}</button>
                                </div>)
                                }
                            })
                    }

                </div>
            }
            {
                sortedArray.length === 0 &&
                <p className="text-center h6 "> No Teams Available</p>
            }

            {
                <div className="col-10 mx-auto mt-5">
                    <div className="d-flex flex-row flex-wrap justify-content-center">
                        <div className="col-4">
                            <i className="fa fa-square" data-radium="true" style={{ color: "#1F9858" }}></i>&nbsp;Organisation Team
                             </div>
                        <div className="col-4">
                            <i className="fa fa-square" data-radium="true" style={{ color: "#436FA0" }}></i>&nbsp;Virtual Team
                             </div>
                        <div className="col-4">
                            <i className="fa fa-square" data-radium="true" style={{ color: "#EE0033" }}></i>&nbsp;Shared Team
                             </div>
                    </div>
                </div>
            }

        </div >
        return returnData


    }
    toggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    applyFilter() {
        this.setState({
            applyFilter: !this.state.applyFilter
        });
    }


    onClickResponseHandler(type, returnData) {
        if(type === 'Apply Filters' && this.props.analyzeFilterData) {
            let FilterForm = [...this.state.FilterForm];
            let analyzeFilterData = [...this.props.analyzeFilterData.team_members];
            let analyzeFilterSkeleton = {
                age: [],
                gender: {},
                marital_status: {},
                Children_between: {},
                family_type: {},
                work_experience: {},
                occupation: {},
                Designation: {},
                Qualification: {},
                industry: {},
                Tenure: {},
                Annual_income: {
                    data: []
                },
                city: [],
                country: []
            };
            let analyzeFilterPostData = [];
            
            FilterForm.map(val => {
                if(val.data) {
                    val.data.map(value => {
                        if(value.key === "age_between" || value.key === "age_and") {
                            analyzeFilterSkeleton.age[value.key] = value.value === '' ? 0 : parseInt(value.value, 10)
                        }else if(value.key === "user__gender"){
                            analyzeFilterSkeleton.gender[value.label] = value.value
                        }else if(value.key === "Marital status"){
                            analyzeFilterSkeleton.marital_status[value.label] = value.value
                        }else if(value.key.includes('Children_between') || value.key.includes('Children_and')){
                            analyzeFilterSkeleton.Children_between[value.key] = value.value === '' ? 0 : parseInt(value.value, 10)
                        }else if(value.key === 'Family Type') {
                            if(value.label === "Joint" || value.label === 'JointNuclear') {
                                analyzeFilterSkeleton.family_type[value.label] = value.value
                            }
                        }else if(value.key === 'city') {
                            if(value.value) {
                                analyzeFilterSkeleton["city"].push(value.label)
                            }
                        }else if(value.key === 'country') {
                            if(value.value) {
                                analyzeFilterSkeleton["country"].push(value.label)
                            }
                        }else if(value.dataFilter === "work_experience") {
                            analyzeFilterSkeleton.work_experience[value.key] = value.value === '' ? 0 : parseInt(value.value, 10)                           
                        }else if(value.key === 'occupation') {
                            analyzeFilterSkeleton.occupation[value.label] = value.value
                        }else if(value.key === 'Designation') {
                            analyzeFilterSkeleton.Designation[value.label] = value.value                            
                        }else if(value.key === 'Qualification') {
                            analyzeFilterSkeleton.Qualification[value.label] = value.value
                        }else if(value.key === 'industry') {
                            analyzeFilterSkeleton.industry[value.label] = value.value                            
                        }else if(val.mainLabel === "Tenure in company:") {
                            analyzeFilterSkeleton.Tenure[value.label] = value.value  === '' ? 0 : parseInt(value.value, 10)                           
                        }else if(value.key === "Annual income") {
                            if(value.value) {
                                analyzeFilterSkeleton.Annual_income["data"].push(value.data)
                            }
                        }
                        // else if(val.type === 'radio') {
                        //     analyzeFilterSkeleton[value.label] = value.value
                        // }
                    })
                }
            })

            let filterOptions = {
                age: [],
                marital_status: [],
                children: [],
                family_type: [],
                city: [],
                country: [],
                work_experience: [],
                occupation: [],
                Designation: [],
                Qualification: [],
                industry: [],
                gender: [],
                tenure_in_company: [],
                annual_income: {
                    type: 'range',
                    data: []
                }
            }

            let dataToFilter = []

            analyzeFilterData.map(val => {
                if(val.user_details.length !== 0) {
                    let obj = {
                        is_team_leader: val.is_team_leader,
                        age: val.age,
                        marital_status: val.user_details[0].marital_status,
                        children: val.user_details[0].no_of_children,
                        family_type: val.user_details[0].family_type,
                        city: val.user_details[0].city,
                        country: val.user__country__country_name,
                        work_experience: val.user_details[0].work_experience,
                        occupation: val.user_details[0].occupation,
                        Designation: val.user_details[0].designation,
                        Qualification: val.user_details[0].qualification__demographic_name,
                        industry: val.user_details[0].industry__demographic_name,
                        gender: val.user__gender,
                        tenure_in_company: val.user_details[0].tenure_in_company,
                        annual_income: val.user_details[0].annual_income,
                        assessment_id: val.assessment.id,
                        created: val.assessment.created,
                        user__date_of_birth: val.user__date_of_birth,
                        user__full_name: val.user__full_name,
                        user_email: val.user_email,
                        relationFilter: val.relationFilter !== undefined ? val.relationFilter : true
                    }
                    dataToFilter.push(obj)
                }else {
                    let obj = {
                        is_team_leader: val.is_team_leader,
                        age: val.age,
                        marital_status: '',
                        children: '',
                        family_type: '',
                        city: '',
                        country: val.user__country__country_name,
                        work_experience: '',
                        occupation: '',
                        Designation: '',
                        Qualification: '',
                        gender: val.user__gender,
                        industry: '',
                        tenure_in_company: '',
                        annual_income: '',
                        assessment_id: val.assessment.id,
                        created: val.assessment.created,
                        user__date_of_birth: val.user__date_of_birth,
                        user__full_name: val.user__full_name,
                        user_email: val.user_email,
                        relationFilter: val.relationFilter !== undefined ? val.relationFilter : true
                    }
                    dataToFilter.push(obj)                    
                }
            })

            //annual
            for (let index = 0; index < analyzeFilterSkeleton.Annual_income.data.length; index++) {
                const element = analyzeFilterSkeleton.Annual_income.data[index];
                filterOptions.annual_income.data.push({
                    min: element.min,
                    max: element.max
                })                
            }

            //age
            for (let i = analyzeFilterSkeleton.age.age_between; i <= analyzeFilterSkeleton.age.age_and; i++) {
                if(i === 0 && analyzeFilterSkeleton.age.age_between === analyzeFilterSkeleton.age.age_and) {
                }else {
                    filterOptions.age.push(i)
                }
            }

            //marital_status
            for (const key in analyzeFilterSkeleton.marital_status) {
                if (analyzeFilterSkeleton.marital_status.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.marital_status[key];
                    if(element) {
                        filterOptions.marital_status.push(key)
                    }
                }
            }

            //no of children
            for (let i = analyzeFilterSkeleton.Children_between["No of Children_between"]; i <= analyzeFilterSkeleton.Children_between["No of Children_and"]; i++) {
                if(i === 0 && analyzeFilterSkeleton.Children_between["No of Children_between"] === analyzeFilterSkeleton.Children_between["No of Children_and"]) {
                }else {
                    filterOptions.children.push(i)
                }        
            }

            //family type
            for (const key in analyzeFilterSkeleton.family_type) {
                if (analyzeFilterSkeleton.family_type.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.family_type[key];
                    if(element) {
                        filterOptions.family_type.push(key)
                    }
                }
            }

            //gender
            for (const key in analyzeFilterSkeleton.gender) {
                if (analyzeFilterSkeleton.gender.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.gender[key];
                    if(element) {
                        filterOptions.gender.push(key)
                    }
                }
            }

            //city
            filterOptions.city = analyzeFilterSkeleton.city

            //country
            filterOptions.country = analyzeFilterSkeleton.country

            //work exp
            for (let i = analyzeFilterSkeleton.work_experience["Work Experience_between"]; i <= analyzeFilterSkeleton.work_experience["Work Experience_and"]; i++) {
                if(i === 0 && analyzeFilterSkeleton.Children_between["Work Experience_between"] === analyzeFilterSkeleton.Children_between["Work Experience_and"]) {
                }else {
                    filterOptions.work_experience.push(i)
                }
            }

            //occupation
            for (const key in analyzeFilterSkeleton.occupation) {
                if (analyzeFilterSkeleton.occupation.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.occupation[key];
                    if(element) {
                        filterOptions.occupation.push(key)
                    }
                }
            }
            
            //Designation
            for (const key in analyzeFilterSkeleton.Designation) {
                if (analyzeFilterSkeleton.Designation.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.Designation[key];
                    if(element) {
                        filterOptions.Designation.push(key)
                    }
                }
            }

            //Qualification
            for (const key in analyzeFilterSkeleton.Qualification) {
                if (analyzeFilterSkeleton.Qualification.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.Qualification[key];
                    if(element) {
                        filterOptions.Qualification.push(key)
                    }
                }
            }

            //industry
            for (const key in analyzeFilterSkeleton.industry) {
                if (analyzeFilterSkeleton.industry.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.industry[key];
                    if(element) {
                        filterOptions.industry.push(key)
                    }
                }
            }

            //tenure
            for (let i = analyzeFilterSkeleton.Tenure.Between; i <= analyzeFilterSkeleton.Tenure.and; i++) {
                if(i === 0 && analyzeFilterSkeleton.Tenure.Between === analyzeFilterSkeleton.Tenure.and) {
                }else {
                    filterOptions.tenure_in_company.push(i)
                }
            }
        

            function range(range: any[], value: number) {
                let flag = true;
                for (let index = 0; index < range.length; index++) {
                  const el = range[index];
                  if (value >= el.min && value <= el.max) {
                    flag = true;
                    break;
                  } else {
                    // return false;
                    flag = false;
                  }
                }
                return flag ? true : false;
            }


            function multiFilter(arr, filters) {
                const array = [...arr]
                const filter = filters;
                
                array.forEach((obj) => {
                    for (const key in filter) {
                        if (obj.hasOwnProperty(key)) {
                            if(filter[key].type === 'range') {
                                if (obj[key]) obj["filtered"] = range(filter[key].data, +obj[key]);
                                else obj["filtered"] = range(filter[key].data, obj[key]);
                            }else if (filter[key].indexOf(obj[key]) != -1) {
                                obj["filtered"] = true;
                                continue;
                            } else {
                                obj["filtered"] = false;
                                break;
                            }
                        }
                    }
                });

                return array
            }

            
            

            let filterOptionsAltered = {}

            for (const key in filterOptions) {
                if (filterOptions.hasOwnProperty(key)) {
                    const element = filterOptions[key];
                    if(element.length !== 0) {
                        filterOptionsAltered[key] = element
                    }
                }
            }




            const multiFilter_filteredData = [...multiFilter(dataToFilter, filterOptionsAltered)]

            let afterAnnualIncome_filteredData = [...multiFilter_filteredData]

            if(returnData) {
                return {
                    data: afterAnnualIncome_filteredData,
                    options: filterOptionsAltered
                }
            }

            this.setState({
                multiFilter_filteredData: afterAnnualIncome_filteredData
            }, () => {
                var arr = [];
                var temp = this.state.multiFilter_filteredData;
                if(Object.keys(filterOptionsAltered).length !== 0) {
                    temp.map((obj) => {
                        if(obj.filtered && obj.relationFilter){
                            arr.push(obj.assessment_id)
                        }
                    })
                }else {
                    temp.map((obj) => {
                        arr.push(obj.assessment_id)
                    })
                }                
                
                
                const data_ob = {
                    team_members: [],
                    assessor_groups_for_team: this.props.analyzeFilterData.assessor_groups_for_team
                } 
                this.state.multiFilter_filteredData.map((obj) => {
                    data_ob.team_members.push({
                        is_team_leader: obj.is_team_leader,
                        age: obj.age,
                        filtered: obj.filtered && obj.relationFilter,
                        relationFilter: obj.relationFilter,
                        assessment: {
                            created: obj.created,
                            id: obj.assessment_id
                        },
                        user__country__country_name: obj.country,
                        user__date_of_birth: obj.user__date_of_birth,
                        user__full_name: obj.user__full_name,
                        user_email: obj.user_email,
                        user__gender: obj.gender,
                        user_details: [
                            {
                                annual_income: obj.annual_income,
                                city: obj.city,
                                designation: obj.Designation,
                                family_type: obj.family_type,
                                industry__demographic_name: obj.industry,
                                marital_status: obj.marital_status,
                                no_of_children: obj.children,
                                occupation: obj.occupation,
                                qualification__demographic_name: obj.Qualification,
                                tenure_in_company: obj.tenure_in_company,
                                work_experience: obj.work_experience,
                            }
                        ]
                    })
                })


                const fd = {
                    "assessorIds": this.props.analyzeFilterData.assessor_groups_for_team.map(val => val.id),
                    "assessmentIds": arr,
                }


                const fd1 = {
                    'assessor_groups_for_team': this.props.analyzeFilterData.assessor_groups_for_team,
                    'team_members': data_ob.team_members
                }
                
                //team members and respondents
                this.props.dispatch(analyseActions.saveAssessorGroups(fd1))
                
                
                this.props.dispatch(analyseActions.saveAssessorIds(fd))
                if(arr.length) {

                    this.apiCallStackInBackground(this.props.analyzeFilterData.assessor_groups_for_team.map(val => val.id), arr, fd1)

                }
                this.setState({
                    FilteredFormnAnalyze: {
                        "team_assessment_id": arr,
                        "relation_group_ids": this.props.analyzeFilterData.assessor_groups_for_team.map(val => val.id)}
                    }, () => {
                })
                
                if(this.props.callBack) {
                    this.props.callBack(data_ob)
                }
                let countOfFilteredObj = 0
                if(Object.keys(filterOptionsAltered).length !== 0) {
                    data_ob.team_members.map(val => {
                        if(val.filtered) {
                            countOfFilteredObj++
                        }
                    })
                }else {
                    countOfFilteredObj = this.state.multiFilter_filteredData.length
                }
                this.setState({
                    openFilterModal: false,
                    data_ob_filtered: data_ob,
                    countOfFilteredObj
                },() => {
                    const {dispatch} = this.props;

                    function showFilteredItems() {
                        let stringText = ''
                        if(filterOptionsAltered.annual_income) {
                            if(filterOptionsAltered.annual_income.data.length) {
                                stringText = stringText + `Annual Income${Object.keys(filterOptionsAltered).length !== 1 ? ', ' : ''}`
                            }
                        }
                        stringText = stringText + Object.keys(filterOptionsAltered).filter(val => {
                            if(val !== 'annual_income') {
                                return val
                            }
                        }).join(', ')
                        return stringText.length ? stringText : 'No Filters Applied'
                    }


                    dispatch({
                        type: 'ADD_FILTER_FORM',
                        payload: this.state.FilterForm,
                        filter_used: showFilteredItems()
                    })
                })

            })

        }else if(type === 'Remove All Filters') {
            let FilterForm = [...this.state.FilterForm]
            FilterForm.map(val => {
                if(val.data) {
                    val.data.map(value => {
                        if(val.type === 'checkbox') {
                            value.value = false
                        }else if(val.type === 'number') {
                            value.value = ''
                        }
                    })
                }
            })
            let analyzeFilterData = this.props.analyzeFilterData
            analyzeFilterData.team_members.map(val => {
                val.filtered = val.relationFilter
            })

            const data_ob_filtered = {
                team_members: this.state.data_ob_filtered.team_members
            }

            const fd = {
                "assessorIds": analyzeFilterData.assessor_groups_for_team.map(val => val.id),
                "assessmentIds": analyzeFilterData.team_members.filter(val => val.filtered).map(val => val.assessment.id),
            }

            const fd1 = {
                'assessor_groups_for_team': analyzeFilterData.assessor_groups_for_team,
                'team_members': analyzeFilterData.team_members
            }

            //team members and respondents
            this.props.dispatch(analyseActions.saveAssessorGroups(fd1))

            
            this.props.dispatch(analyseActions.saveAssessorIds(fd))

            this.apiCallStackInBackground(fd.assessorIds, fd.assessmentIds, fd1)

            if(this.props.callBack) {
                this.props.callBack(analyzeFilterData)
            }
            this.setState({
                data_ob_filtered,
                openFilterModal: false,                
                FilterForm,
                countOfFilteredObj: this.props.analyzeFilterData.team_members.length
                // openFilterModal: false
            },() => {
                const {dispatch} = this.props;
                // this.props.dispatch(AnalyzeAction.AnalyzeDataAction({"team_assessment_id": this.state.FilteredFormnAnalyze.team_assessment_id.length ? this.state.FilteredFormnAnalyze.team_assessment_id : assessmentIds,"relation_group_ids": assessorIds}))
                dispatch({
                    type: 'ADD_FILTER_FORM',
                    payload: this.state.FilterForm,
                    filter_used: 'Filters Removed'
                })
            })
        }
        else if (type === 'Cancel') {
            this.setState({
                openFilterModal: false
            })
        }
    }

    onClickTeam(data) {
        const assessorIds = [];
        const assessmentIds = [];
        localStorage.setItem('teamId', data.id)
        localStorage.setItem('teamName', data.team_name)
        this.setState({
            openTeamModal: false,
            teamName: data.team_name,
            teamId: data.id,
            assessorArray: [],
            //add loader to set save_assessor_ids and save_assessor_group added because dispatches are async
            changeTeamState: true
        }, () => {
            const fd = {
                'teamName': data.team_name,
                'teamId': data.id,
                'orgId': this.props.orgId
            }
            this.props.dispatch(saveTeamDetailsAction.saveTeamDetailHandler(fd))
            const team = {
                "team_id": data.id
            }
             //assessor_groups_for_team & team_members
             this.props.dispatch(analyseActions.getAssessorGroupsHandler(team,(callback_Data) => {
                if(callback_Data) {
                    const assessor_groups_for_team_temp = []
                    callback_Data.data.assessor_groups_for_team.map(
                        (data, i) => {
                            assessor_groups_for_team_temp.push(data)
                        }
                    )
                    const fd1 = {
                        'assessor_groups_for_team': assessor_groups_for_team_temp,
                        'team_members': callback_Data.data.team_members
                    }
                    //team members and respondents
                    this.props.dispatch(analyseActions.saveAssessorGroups(fd1))
                    if(fd1.team_members.length > 1) {
                        for (let i = 0; i < fd1.assessor_groups_for_team.length; i++) {
                            if (fd1.assessor_groups_for_team[i].value === true) {
                                assessorIds.push(fd1.assessor_groups_for_team[i].id)
                            }
                        }
                        for (let i = 0; i < fd1.team_members.length; i++) {
                            assessmentIds.push(fd1.team_members[i].assessment.id)
                        }

                        this.apiCallStackInBackground(assessorIds, assessmentIds, fd1)
                    }
                    const fd3 = {
                        "assessorIds": assessorIds,
                        "assessmentIds": assessmentIds,
                    }
                    //Assessment id's and respondent id's
                    this.props.dispatch(analyseActions.saveAssessorIds(fd3))
                }
            }))
        })
    }

    propsChanged = (event, parentIdentifier, identifier, type) => {
        const updatedData = this.state.FilterForm;
        const updatedElement = updatedData[parentIdentifier].data[identifier];

        if (type === 'checkbox' || type === 'radio') {
            updatedElement.value = event.target.checked
        } else {
            updatedElement.value = event.target.value
        }


        this.setState({ formData: updatedData });
    }

    onChangeAssessorname = (event, assessorDetails) => {
        sub$.next({checkedVal: event.target.checked, assessorDetails})
        const updatedData = this.state.assessorArray.length === 0 ? this.getReformatAssessorGroupList(this.props.analyzeFilterData.assessor_groups_for_team) : this.state.assessorArray;
        
        let counter = 0;
        let allRelationSelect = false
        
        updatedData.map(
            (data, i) => {
                if (data.id === assessorDetails.id) {
                    data.value = event.target.checked
                }

                if(data.value) {
                    counter++
                }
            }
        )

        if(counter === updatedData.length) {
            allRelationSelect = true
        }

        this.setState({
            assessorArray: updatedData,
            allRelationSelect
        })
    }

    componentWillUnmount() {
        
        window.removeEventListener("resize", this.resize.bind(this));


        TakeUntillAvailable$
        .next()
    }

    onClickAllChecked = (event) => {
        const targetChecked = event.target.checked
        this.setState({isDisabled: true}, () => {
    
            const { saveAssesorGroupListResponse } = this.props;

            let updatedData = this.state.assessorArray.length === 0 ? this.getReformatAssessorGroupList(this.props.analyzeFilterData.assessor_groups_for_team) : this.state.assessorArray;
    
            let updatedData_main = []

            if(targetChecked) {
                updatedData_main = updatedData.map(data => {
                    return {
                        ...data,
                        value: true
                    }
                })
            }else {
                updatedData_main = updatedData.map(data => {
                    return {
                        ...data,
                        value: false
                    }
                })
            }
    
            const assessorIdsArr = updatedData_main.filter(assessor => assessor.value).map(assessor => assessor.id)
            
            const fdTeam_list = {
                assessor_group_ids: assessorIdsArr,
                assessment_ids: saveAssesorGroupListResponse.team_members.map(team => team.assessment.id)
            }
    
            this.props.dispatch(analyseActions.get_team_member_id(fdTeam_list))
    
    
            this.setState({ assessorArray: updatedData_main, allRelationSelect: !this.state.allRelationSelect })

        })
    }

    getReformatAssessorGroupList = (assessorList) => {
        let returnData = []
        if(this.state.assessorListEnabledArr.length) {
            // const assessorListEnabledId = this.state.assessorListEnabledArr.map(asessor => asessor.id)
            // const assessorListFiltered = assessorList.filter(assessor => assessorListEnabledId.includes(assessor.id))
            this.state.assessorListEnabledArr.map(
                (data, i) => {
                    returnData.push({
                        ...data,
                        'value': data.value
                    })
                }
            )
        }
        return returnData
    }

    getFilterForm() {


        const data =
            <div className="m-0 p-0" style={{ backgroundColor: 'white', color: 'black', overflowY: 'auto', maxHeight: '450px' }}>
                <div>
                    <div style={{ columns: '3', columnRule: '1px solid black' }}>
                        {
                            this.state.FilterForm.map(
                                (form, i) => {
                                    return <React.Fragment key={i}>
                                        {
                                            form.heading &&
                                            <p className="font-weight-bold text-center mb-0">{form.heading}</p>
                                        }
                                        {
                                            form.subHeading &&
                                            <small style={{ display: 'block' }} className=" text-center">{form.subHeading}</small>
                                        }
                                        {
                                            (!form.heading && !form.subHeading) &&
                                            <div className="my-2 p-3" style={{ backgroundColor: "rgb(241, 241, 241)", width: "100%", padding: '5px', breakInside: 'avoid' }}>
                                                {
                                                    form.mainLabel !== '' &&
                                                    <label style={{ margin: '0px', padding: '0px 0px 5px' }}>{form.mainLabel}</label>
                                                }

                                                <div style={{}}>
                                                    {
                                                        form.type === 'text' || form.type === 'number' &&
                                                        form.data.map(
                                                            (innerForm, id) => {
                                                                return (
                                                                    <React.Fragment key={id}>
                                                                        <span> {innerForm.label} </span>
                                                                        <input onChange={(event) => this.propsChanged(event, i, id, form.type)} type={form.type} value={innerForm.value} style={{ width: '45px' }} />
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        )
                                                    }

                                                    {
                                                        form.type === 'checkbox' &&
                                                        form.data.map(
                                                            (innerForm, id) => {
                                                                return (
                                                                    <React.Fragment key={id}>
                                                                        <label className="font-weight-normal" style={{ display: " inline-block", paddingRight: "10px" }}>
                                                                            <input onChange={(event) => this.propsChanged(event, i, id, form.type)} type="checkbox" checked={innerForm.value} />
                                                                            &nbsp;{innerForm.label}
                                                                        </label>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        )
                                                    }

                                                    {
                                                        form.type === 'radio' &&
                                                        form.data.map(
                                                            (innerForm, id) => {
                                                                return (
                                                                    <React.Fragment key={id}>
                                                                        <label className="font-weight-normal" style={{ display: " inline-block", paddingRight: "10px" }}><input onChange={(event) => this.propsChanged(event, i, id, form.type)} type="radio" name={innerForm.name} checked={innerForm.value} />&nbsp;{innerForm.label}</label>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        }

                                    </React.Fragment>
                                }
                            )
                        }
                    </div>
                </div>
            </div>

        return data
    }

    toggleOrganisationTooltip() {
        this.setState({
            tooltipOrganisation: !this.state.tooltipOrganisation
        })
    }

    findTeamLeaderExists(team_members) {
        return team_members.some(member => {
            if(member.filtered !== undefined) {
                if(member.filtered) {
                    return member.is_team_leader === true
                }
            }else {
                return member.is_team_leader === true
            }
        })
    }

    renderTeamLeader(team_members) {
        return team_members.map((member, key) => {
            if(member.filtered !== undefined) {
                if(member.filtered) {
                    return (
                        member.is_team_leader === true &&
                        <p key={key} className="mb-0" style={{fontSize: 18, color: "#ddde46"}} >{member.user__full_name}</p>
                    )
                }
            }else {
                return (
                    member.is_team_leader === true &&
                    <p key={key} className="mb-0" style={{fontSize: 18, color: "#ddde46"}} >{member.user__full_name}</p>
                )
            }
        })
    }

    renderTeamMember(team_members) {
        return team_members.map((val, key) => {
            if(val.filtered !== undefined) {
                if(val.filtered) {
                    if(val.is_team_leader === false) {
                        return (
                            <div key={key} className="d-flex align-items-center justify-content-center pr-2 mt-1 mb-1">
                                <p className="col-12 px-0 mb-0" style={{fontSize:'1rem'}}>{val.user__full_name ? val.user__full_name : val.user_email}</p>
                            </div>
                        )
                    }
                }
            }else {
                if(val.is_team_leader === false) {
                    return (
                        <div key={key} className="d-flex align-items-center justify-content-center pr-2 mt-1 mb-1">
                            <p className="col-12 px-0 mb-0" style={{fontSize:'1rem'}}>{val.user__full_name ? val.user__full_name : val.user_email}</p>
                        </div>
                    )
                }
            }
        })
    }

    checkTeamMemberLengthAndRenderMembersAccordingly(team_members) {
        return (
            team_members.length === 0 ?
                <p className="mt-3" style={{fontSize:'1rem'}}>No Team Members Found</p>
            :
                this.renderTeamMember(team_members)
        )

    }

    renderRelationList(assessor_groups_for_team) {
        return (this.state.assessorArray.length === 0 ? this.getReformatAssessorGroupList(assessor_groups_for_team) : this.state.assessorArray).map((val, key) => {
            return (
                <div key={key}>
                    <label id="relation-checkox" className="col-12 d-flex align-items-center justify-content-center  pl-1 pr-2 m-1  cursor-pointer" style={{fontSize:'1rem'}}>
                        {
                            // this.state.isDisabled ?
                            // <input disabled checked={val.value} onChange={(event) => { this.onChangeAssessorname(event, val) }} className="col-1 mt-0" type="checkbox" style={{cursor: 'pointer'}}></input>:
                            <input checked={val.value} onChange={(event) => { this.onChangeAssessorname(event, val) }} className="col-1 mt-0" type="checkbox" style={{cursor: 'pointer'}}></input>
                        }
                        <p className="col-11 mb-0">{val.assessor_name}</p>
                    </label>
                </div>
            )
        })
    }

    render() {
        const { sideNavItems, organisationName, orgId, analyzeFilterData,
            getOrgTeamsResponse, saveTeamDetailsResponse, paAnaTeamListError,
            paAnaTeamListLoading, assessorGroupsLoading,
            assessorGroupsError, userListLoading, userListError, team_id_group_list_loading, team_id_group_list_error } = this.props

        
        return (
            <React.Fragment>
                <div className={`${this.props.isAnalyse === true ? `sidebar-container sidenav-over ${this.state.collapseSideNav ? 'collapse-sidenav-active' : 'collapse-sidenav-inactive'}`: 'sidebar-container sidenav-over collapse-sidenav-active'}`}>
                    {
                        this.props.isAnalyse === true && this.state.hideSideNav ?
                            <div className="sideNav-hamburger">
                                <i class="fas fa-bars" onClick={() => {
                                    this.setState({
                                        collapseSideNav: !this.state.collapseSideNav
                                    })
                                }}></i>
                            </div>
                        :
                            null
                    }
                    <div className="sidebar-content-view">
                        <div className="d-flex flex-row justify-content-between align-items-center sidebar-org-div p-3" style={{height: 64}}>
                            <div>
                                <h6 className="mb-0 text-dark ">{organisationName}</h6>
                            </div>
                            <div>
                                <Link to={`/`}><i className="fa fa-caret-right mb-0" style={{ fontSize: '1.6rem', color: '#000' }} id="TooltipOrganisation" ></i></Link>
                                <Tooltip placement="top" isOpen={this.state.tooltipOrganisation} target="TooltipOrganisation" toggle={this.toggleOrganisationTooltip} delay={{ show: 0, hide: 5 }}>
                                    Change Organisation
                                </Tooltip>
                            </div>
                        </div>
                    {
                        sideNavItems != undefined ?
                            sideNavItems.length != 0 ?
                                sideNavItems.map((val, key) => {
                                    return (
                                        <div key={key} className="sidebar-orgdata">
                                            <RouterLink to={`/organisation/${orgId}/${val.link}`} className="text-white no-underline">
                                                <div className="flex-column flex-grow-1">
                                                    {val.name}</div></RouterLink>
                                        </div>
                                    )
                                })
                                :
                                null
                            :
                            null
                    }

                    {
                        this.props.isAnalyse === true &&
                        <React.Fragment>
                            <div className="d-flex flex-row  justify-content-between align-items-center sidebar-org-filter-div p-3">
                                <div>
                                    {
                                        (!userListLoading && !userListError) && (!paAnaTeamListError && !paAnaTeamListLoading) &&(!assessorGroupsLoading && !assessorGroupsError) ?
                                            <React.Fragment>
                                                <div>
                                                    <p className="text-black" style={{marginBottom: 0}}>Team</p>
                                                </div>
                                                <div>
                                                    <p className="mb-2 text-black font-weight-bold" style={{fontSize: '1rem'}}>{this.state.teamName === '' ? this.props.teamName === '' ? 'No Teams Available' : this.props.teamName : this.state.teamName}</p>
                                                </div>
                                            </React.Fragment>
                                        :
                                            <p className="text-center my-3 text-white">
                                                <i className="fas fa-spinner fa-spin " ></i>
                                                &nbsp;loading
                                            </p> 
                                    }
                                </div>
                                <div >
                                    <i className="fa fa-caret-right mb-0" style={{ fontSize: '1.6rem', color: "#000", cursor: "pointer" }} id="TooltipExample" onClick={() => { this.setState({ openTeamModal: true }) }}></i>
                                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TooltipExample" toggle={this.toggle} delay={{ show: 0, hide: 5 }}>
                                        Change Team
                                        </Tooltip>
                                </div>
                            </div>
                            <div className="px-3 sidebar-checkbox-container">
                                {

                                        (!userListLoading && !userListError) && (!paAnaTeamListError && !paAnaTeamListLoading) && (!assessorGroupsLoading && !assessorGroupsError) ?
                                        analyzeFilterData != undefined && analyzeFilterData != null &&
                                            <div>
                                                {
                                                    analyzeFilterData.assessor_groups_for_team.length ?
                                                        <div>
                                                            <div className="d-flex align-items-center justify-content-center sidebar-checkbox-main p-1 ml-1 mt-3">
                                                                <label className="col-12 d-flex align-items-center pl-0 pr-2 m-1 cursor-pointer" style={{fontSize:'1rem'}}>
                                                                    <input checked={this.state.allRelationSelect} onChange={(event) => { this.onClickAllChecked(event) }} className="col-1 mt-0" type="checkbox"></input>
                                                                    <p className="col-11 mb-0">Relations</p>
                                                                </label>
                                                            </div>
                                                            {
                                                                this.renderRelationList(analyzeFilterData.assessor_groups_for_team)
                                                            }
                                                        </div>
                                                    :
                                                        <p className="mt-3">No Relations Found</p>
                                                }  
                                            </div>
                                        :
                                            userListLoading || paAnaTeamListLoading || assessorGroupsLoading ?
                                                <p className="text-center mt-4">
                                                    <i className="fas fa-spinner fa-spin " ></i>
                                                    &nbsp;loading
                                                </p>
                                            :
                                                analyzeFilterData != undefined && analyzeFilterData != null ?
                                                    analyzeFilterData.assessor_groups_for_team.length === 0 &&
                                                        <p className="mt-3">No Relations Found</p>
                                                :
                                                    null
                                }
                            </div>
                            <div className="d-flex flex-row justify-content-between align-items-center sidebar-org-filter-div p-3">
                                <div>
                                    <div>
                                        <p className="text-black " style={{marginBottom: 0}}>Filter</p>
                                    </div>
                                    <div>
                                        <p className="mb-2 text-black font-weight-bold"  style={{fontSize: '1rem'}}>{this.props.filter_used}</p>
                                    </div>
                                </div>
                                <div>
                                    <i className="fa fa-caret-right mb-0" style={{ fontSize: '1.6rem', color: "#000", cursor: "pointer" }} id="ApplyFilter" onClick={() => {
                                        
                                        this.setState({ openFilterModal: true })   
                                    }}></i>
                                    <Tooltip placement="top" isOpen={this.state.applyFilter} target="ApplyFilter" toggle={this.applyFilter} delay={{ show: 0, hide: 5 }}>
                                        Apply Filter
                                    </Tooltip>
                                </div>
                            </div>
                            {
                                !this.state.changeTeamState && (!userListLoading && !userListError) && (!paAnaTeamListError && !paAnaTeamListLoading) && (!assessorGroupsLoading && !assessorGroupsError) && (!team_id_group_list_loading && !team_id_group_list_error) ?
                                (analyzeFilterData != undefined && analyzeFilterData != null) &&
                                    <div className="px-3 sidebar-checkbox-container">
                                        {
                                            this.findTeamLeaderExists(analyzeFilterData.team_members) ?
                                                <div>
                                                    <div className="sidebar-checkbox-main">
                                                        <p className="mb-0 px-2" style={{fontSize: 16, color: "#b5b5b5"}} >Team Leader</p>
                                                    </div>
                                                    <div className="pr-3 py-2 font-weight-bold">
                                                        {
                                                            this.renderTeamLeader(analyzeFilterData.team_members)
                                                        }
                                                    </div>
                                                </div>
                                            :
                                                <p className="mb-0" style={{fontSize: 16}} >No Team Leader</p>
                                        }
                                        <div className="d-flex align-items-center justify-content-center sidebar-checkbox-main pl-1">
                                            <p className="col-12 px-1 mb-0 font-weight-bold" style={{fontSize: 16, color: "#b5b5b5"}}>{analyzeFilterData.team_members.filter(val => val.filtered !== undefined ? val.filtered && val.is_team_leader === false ? val : false : val.is_team_leader === false ? val : false).length} Team Members</p>
                                        </div>
                                        <div className="sidebar-team-members-container">
                                            {
                                                this.checkTeamMemberLengthAndRenderMembersAccordingly(analyzeFilterData.team_members)
                                            }
                                        </div>
                                    </div> 
                                : 
                                    this.state.changeTeamState || userListLoading || paAnaTeamListLoading || assessorGroupsLoading || team_id_group_list_loading ?
                                        <p className="text-center mt-4">
                                            <i className="fas fa-spinner fa-spin " ></i>
                                            &nbsp;loading
                                        </p>
                                    :
                                        analyzeFilterData != undefined && analyzeFilterData != null ?
                                            analyzeFilterData.team_members.length === 0 &&
                                                <p className="mt-3 px-3">No Team Members Found</p>
                                        :
                                            null
                            }

                            

                        </React.Fragment>


                    }

                    {
                        this.props.virtualTeamFilter ?
                            <div 
                                style={{background: '#fffc8e',color: "#000",}} 
                                className="mt-3 p-2 d-flex justify-content-between cursor-pointer"
                                onClick={() => this.props.virtualTeamState()}
                            >
                                <p style={{fontSize: '1rem'}} className="mb-0">Team Filter</p>
                                <i className="fa fa-caret-right mb-0" style={{ fontSize: '1.6rem' }} id="ApplyFilter"></i>
                            </div>
                        :
                            null
                    }

                    {
                        this.state.openTeamModal &&
                        <ModalComponent
                            showModal={this.state.openTeamModal}
                            heading="Change Team"
                            htmlTag={this.getOrgTeamReformatData(this.props.getPaAnanlyzeTeamListResponse.data !== '' ? this.props.getPaAnanlyzeTeamListResponse.data : [], 'Modal')}
                            footerNonSubmitButton={[{
                                'buttonName': 'Cancel',
                            }]}
                            responseHandler={(type) => { this.setState({ openTeamModal: false }) }}
                            onClickTeam={(data) => {this.onClickTeam(data)}}
                        />
                    }

                    {
                        this.state.openFilterModal &&
                        <Modal centered={false} isOpen={this.state.openFilterModal} fade={false} style={{ maxWidth: '800px', }}>
                            {
                                analyzeFilterData !== undefined && analyzeFilterData !== null &&
                                    <ModalHeader ><span className="h6 pb-3">Filter Team: Filtered team contains {analyzeFilterData.team_members.filter(val => val.filtered !== undefined ? val.filtered ? val : false : val).length} out of {analyzeFilterData.team_members.length} members.</span></ModalHeader>
                            }
                            <ModalBody>
                                {this.getFilterForm()}
                                <ModalFooter style={{ margin: "auto" }} >
                                    {
                                        this.state.footerNonSubmitButton.map(
                                            (buttonData, i) => {
                                                return (
                                                    < button key={i} onClick={() => this.onClickResponseHandler(buttonData.buttonName)} className="btn text-white b-0 " style={{ backgroundColor: "rgb(55, 65, 75)" }}><span className="">{buttonData.buttonName}</span></button>
                                                )
                                            }
                                        )
                                    }

                                </ModalFooter>


                            </ModalBody>

                        </Modal>
                    }
                    </div>
                </div>
            </React.Fragment>
            );
    }
}

SideNavBar.propTypes = {
    sideNavItems: PropTypes.array,
    analyzeFilterData: PropTypes.object,
    organisationName: PropTypes.string,
    orgId: PropTypes.string
};

function mapStateToProps(state) {

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer
    const getModulePermissionsError = state.getModulePermissionsListReducer.error
    const getModulePermissionsListData = (!getModulePermissionsLoading && !getModulePermissionsError) ? state.getModulePermissionsListReducer.data : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';
    const assessorGroupsResponseFull = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data : '';

    //Analyze
    const { getAnalyzeLoading } = state.getAnalyzeData.getAnalyzeLoading
    const { getAnalyzeError} = state.getAnalyzeData.error
    const AnalyzeDataResonse = (!getAnalyzeLoading && !getAnalyzeError) ?  state.getAnalyzeData.data : '';

    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorGrouprelationFilterUsed = state.saveAssesorGroupListReducer.relationFilterUsed;

    const {FilterForm_reducer, filter_form_updated, filter_used} = state.addFilterForm;

     //Pa analytics Team list
     const { paAnaTeamListLoading } = state.getPaAnanlyzeTeamListReducer
     const { paAnaTeamListError} = state.getPaAnanlyzeTeamListReducer.error
     const getPaAnanlyzeTeamListResponse = (!paAnaTeamListLoading && !paAnaTeamListError) ?  state.getPaAnanlyzeTeamListReducer.data : '';

     //availability reducer
     const teamAvailabilityText = state.teamAvailabilityReducer.data;
     const teamAvailabilityBoolean = state.teamAvailabilityReducer.availibility;

     const {userListLoading} = state.userListReducer;
     const userListError = state.userListReducer.error


     const { saveTeamStashLoading } = state.saveStashTeamReducer;
     const stashedTeamData = !saveTeamStashLoading ? state.saveStashTeamReducer.stashedTeamData : [];

     const {team_id_group_list_error,team_id_group_list_loading} = state.team_id_group_list
     const team_id_group_list_data = (!team_id_group_list_error && !team_id_group_list_loading) ? state.team_id_group_list.team_id_group_list_data : ''

    return {

        // getOrgTeamsLoading,
        // getOrgTeamsResponse,
        // saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorIdsResponse,


        //module perm
        getModulePermissionsListData,
        
        saveAssesorGroupListResponse,
        saveAssesorGrouprelationFilterUsed,

        AnalyzeDataResonse,
        FilterForm_reducer,
        filter_form_updated,
        filter_used,
        getPaAnanlyzeTeamListResponse,
        paAnaTeamListError,
        paAnaTeamListLoading,
        
        teamAvailabilityText,
        teamAvailabilityBoolean,
        assessorGroupsLoading,
        assessorGroupsError,

        userListLoading,
        userListError,

        stashedTeamData,
        assessorGroupsResponseFull,

        team_id_group_list_error,
        team_id_group_list_loading,
        team_id_group_list_data

        // saveModulePermissionsResponse,

    }
}

const connectedForm = connect(mapStateToProps)(SideNavBar);

export default withRouter(connectedForm);




// WEBPACK FOOTER //
// ./src/_components/common/SideNavBar/index.js